import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../services/authContext';

const AdminRoute = ({ children }) => {
  const { user, loading, token } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !token) {
      navigate('/login');
    } else if (!loading && token && user && user.role !== 'admin') {
      navigate('/');
    }
  }, [loading, token, user, navigate]);

  if (loading) {
    return <div>Memuat...</div>;
  }

  if (!token) {
    return null;
  }

  if (user && user.role !== 'admin') {
    return (
      <div className="page-container">
        <div className="error-message">
          Akses ditolak. Anda harus menjadi admin untuk mengakses halaman ini.
        </div>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
